// extracted by mini-css-extract-plugin
export var name = "resources-module--name--8594a";
export var nameGen = "resources-module--name-gen--add13";
export var nameGenImg = "resources-module--name-gen-img--7fbfb";